<div class="container-fluid">
    <app-pagetitle title="My Document" [subtitle]="'View and manage your documents'" [actionButton]="{
    label: '+ Send Document',
   onClick: sendDocument
  }"></app-pagetitle>

    <div class="page-content-wrapper">
        <div [class.loading-content]="loading">
            <app-loader [loading]="loading"></app-loader>

            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">

                            <app-filter searchPlaceholder="Document ID, Name, Customer..."
                                [statusOptions]="statusOptions" [initialStatus]="selectedStatus"
                                (filterChange)="onFilterChange($event)"
                                searchHint="Document Id, Name & Customer">
                            </app-filter>

                        </div>
                        <div class="card-body position-relative">
                            <p-table #dt [value]="documents" [lazy]="true" (onLazyLoad)="getDocuments($event)"
                                [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading"
                                [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll"
                                styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Document Id</th>
                                        <th>Name</th>
                                        <th>Customer Name</th>
                                        <th>Status</th>
                                        <th>Progress</th>
                                        <th>Total Signers</th>
                                        <th>Created</th>
                                        <th>Action</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-document>
                                    <tr>
                                        <td class="fw-bold">{{document.documentId}}</td>
                                        <td>{{document.name}}</td>
                                        <td>{{document.customerName}}</td>


                                        <td>
                                            <span class="badge rounded-pill border px-2 p-1" [ngClass]="{
                                        'border-warning text-warning bg-warning-subtle':
                                          document.status?.toLowerCase() === 'pending',
                                        'border-purple text-purple bg-purple-subtle':
                                          document.status?.toLowerCase() !== 'pending'
                                      }">
                                                {{ document.status }}
                                            </span>
                                        </td>
                                        <td>
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar"
                                                    [style.width.%]="getUserStatus(document.signers)" aria-valuemin="0"
                                                    aria-valuemax="100">
                                                    {{document.completedSigners }} / {{
                                                    document.totalSigners }}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="text-center">{{document.totalSigners}}</td>
                                        <td>{{document.createdAt | date}}</td>

                                        <td class="text-center">
                                            <div class="action-wrapper">

                                                <!-- Three dots -->
                                                <button class="btn btn-sm btn-light" (click)="toggleMenu(document._id)">
                                                    ⋮
                                                </button>

                                                <!-- Dropdown -->
                                                <div class="custom-dropdown" *ngIf="activeMenuId === document._id">

                                                    <button class="dropdown-item" (click)="getDocument(document)">
                                                        <i class="mdi mdi-eye fs-4 me-2" style="cursor:pointer;"
                                                            title="View"></i>
                                                        View
                                                    </button>
                                                    <button class="dropdown-item"
                                                        (click)="downloadDocumentAuditTrill(document)">
                                                        <i class="mdi mdi-download fs-4 me-2" style="cursor:pointer;"
                                                            title="Download">
                                                        </i>
                                                        Audit
                                                    </button>
                                                </div>

                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="9" class="text-center py-4 text-muted">
                                            <i class="mdi mdi-database-off-outline me-2"></i>
                                            No document found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        @if(showModal){
        <div class="modal fade show d-block">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title">Document Details</h5>
                        <button class="btn-close" (click)="closeModal()"></button>
                    </div>

                    <div class="modal-body">
                        <div class="row mb-3">
                            <div class="col-12 text-start mb-3">
                                <div class="label fw-semibold">Document ID</div>
                                <div class="value fw-bold fs-6">{{documentDetail.documentId}}</div>
                            </div>
                            <div class="col-12 text-start mb-3">
                                <div class="label fw-semibold">Name</div>
                                <div class="value">{{documentDetail.name }}</div>
                            </div>
                            <div class="col-12 text-start mb-3">
                                <div class="label fw-semibold">Customer Name</div>
                                <div class="value">{{documentDetail.customerName }}</div>
                            </div>
                            <div class="col-12 text-start mb-3">
                                <div class="row">
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="label fw-semibold">Status</div>
                                                <div class="value fw-bold fs-5"> <span
                                                        class="badge rounded-pill border px-2 p-1" [ngClass]="{
                                        'border-warning text-warning bg-warning-subtle':
                                          documentDetail.status?.toLowerCase() === 'pending',
                                        'border-purple text-purple bg-purple-subtle':
                                          documentDetail.status?.toLowerCase() !== 'pending'
                                      }">
                                                        {{ documentDetail.status }}
                                                    </span></div>
                                            </div>
                                            @if(documentDetail.status?.toLowerCase() != 'signed'){
                                            <div class="col-6 pt-4">
                                                <button class="btn btn-primary btn-sm"
                                                    (click)="checkDocumentStatus(documentDetail)">
                                                    {{ loadStatus ? 'Loading...' : 'Check Status' }}
                                                </button>
                                            </div>
                                            }
                                        </div>

                                    </div>
                                    <div class="col-6">
                                        <div class="label fw-semibold">Signing Order</div>
                                        <div class="value ">{{documentDetail.signingOrder | titlecase}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 text-start mb-3">
                                <div class="label fw-semibold">Message</div>
                                <div class="value">{{documentDetail.message || documentDetail.description }}</div>
                            </div>
                            <div class="col-12 text-start mb-3">
                                <div class="label fw-semibold">Recipients</div>
                                @for(signer of documentDetail?.signers; track signer; let i = $index ){
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <div class="d-flex align-items-center">
                                        <div class="value me-2">{{i + 1}}. {{signer.name || 'Customer'}}</div>
                                        <span class="badge rounded-pill border px-2 p-1" [ngClass]="{
                                    'border-warning text-warning bg-warning-subtle': signer.status?.toLowerCase() === 'pending',
                                    'border-purple text-purple bg-purple-subtle': signer.status?.toLowerCase() !== 'pending'
                                }">
                                            {{ signer.status }}
                                        </span>
                                    </div>
                                    @if(signer.status?.toLowerCase() === 'pending') {
                                    <button class="btn btn-outline-primary btn-sm ps-3 pe-3"
                                        (click)="signDocument(signer)">Sign</button>
                                    }
                                    @if(signer.status?.toLowerCase() === 'pending') {
                                    <button class="btn btn-outline-primary btn-sm ps-3 pe-3"
                                        (click)="resendMail(signer)">Resend
                                        Email</button>
                                    }
                                </div>
                                }
                            </div>
                            <div class="col-12 text-start">
                                <div class="label fw-semibold mb-1">Signing Progress</div>
                                <div class="progress" style="height: 12px;">
                                    <div class="progress-bar" role="progressbar"
                                        [style.width.%]="getUserStatus(documentDetail.signers)" aria-valuemin="0"
                                        aria-valuemax="100">
                                        {{
                                        documentDetail.completedSigners }} / {{ documentDetail.totalSigners }}
                                    </div>
                                </div>
                                <div class="value">
                                    {{ documentDetail.completedSigners }} signed
                                    of
                                    {{ documentDetail.totalSigners }}
                                    signers completed.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button class="btn btn-primary"
                            [disabled]="documentDetail.completedSigners != documentDetail.totalSigners"
                            (click)="downloadAndPreview(documentDetail)">
                            <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"
                                aria-hidden="true"></span>
                            {{loading ? 'Loading...' : 'Download Signed Copy'}}</button>
                    </div>

                </div>
            </div>
        </div>

        }

        @if(showModal){
        <div class="modal-backdrop fade show"></div>
        }

    </div>
</div>
